// @flow
import {MAX_PRICES} from '../../utils/constants';

export const getMaxPrice = (currency: string) => {
    return MAX_PRICES[currency.toUpperCase()] || MAX_PRICES.DEFAULT;
};

export const getMaxDisplayPrice = (
    maxAllowedPrice: number,
    maxPrice: ?number
) => {
    return Number.isInteger(maxPrice) && maxPrice
        ? Math.min(maxAllowedPrice, maxPrice)
        : maxAllowedPrice;
};
